var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root"},[_c('h2',{staticClass:"title",class:{
    'title-large': _vm.titleSize === 'large',
    'title-center': _vm.titlePosition === 'center',
    'title-left': _vm.titlePosition === 'left',
  }},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"employees"},_vm._l((_vm.employees),function(employee){return _c('div',{key:employee.id,staticClass:"employee"},[_c('EmployeePortrait',{attrs:{"name":employee.name,"image":employee.image,"title":employee.title,"department":employee.department}})],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }